import clsx from 'clsx';
import type { GridLayout } from '@store/dashboardStore';

interface Props {
  value: GridLayout;
  onChange: (layout: GridLayout) => void;
}

const LAYOUTS: GridLayout[] = ['1x1', '2x2', '3x3', '4x4'];

export function LayoutSwitcher({ value, onChange }: Props): JSX.Element {
  return (
    <div
      role="radiogroup"
      aria-label="Grid layout"
      className="inline-flex rounded-md border border-border bg-surface p-0.5"
    >
      {LAYOUTS.map((opt) => (
        <button
          key={opt}
          role="radio"
          aria-checked={value === opt}
          type="button"
          onClick={() => onChange(opt)}
          className={clsx(
            'rounded px-3 py-1 text-xs font-medium transition-colors',
            'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent',
            value === opt
              ? 'bg-accent/15 text-accent'
              : 'text-muted hover:text-foreground',
          )}
        >
          {opt}
        </button>
      ))}
    </div>
  );
}

